const KEY = "dh_agent_profiles";

function readAll() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}

function writeAll(map) {
  localStorage.setItem(KEY, JSON.stringify(map));
}

export function emptyAgentProfile(session = {}) {
  return {
    agent_name: session.name || "",
    agent_email: session.email || "",
    agent_phone: "",
    agent_title: "Sales associate",
    dre_license: "",
    dre_expires: "",
    office_name: session.office_name || "",
    office_phone: "",
    office_address: "",
    office_city: "",
    office_state: "CA",
    office_zip: "",
    broker_of_record: "",
    website: "",
    mls_id: "",
    api_crm_placeholder: "",
    api_mls_placeholder: "",
    api_calendar_placeholder: "",
    password_hint: "",
    photo: "",
    display_format: "name-title",
    updated_at: null,
  };
}

export function getAgentProfile(userId, session) {
  if (!userId) return emptyAgentProfile(session);
  const stored = readAll()[userId];
  return { ...emptyAgentProfile(session), ...(stored || {}) };
}

export function saveAgentProfile(userId, profile) {
  if (!userId) return profile;
  const all = readAll();
  const next = { ...profile, updated_at: new Date().toISOString() };
  all[userId] = next;
  writeAll(all);
  return next;
}
